/**
 * A API escreve as mensagens sem acento (convenção dela). Na tela de Entrar o
 * texto vai como está para o usuário, então o acerto de grafia e do prefixo
 * técnico do zod ("body/servidor ...") é feito aqui, uma vez.
 */
const COM_ACENTO: Record<string, string> = {
  'Nao foi possivel falar com o servidor desta caixa. Tente de novo em instantes ou entre com a conta Way Mail.':
    'Não foi possível falar com o servidor desta caixa. Tente de novo em instantes ou entre com a conta Way Mail.',
  'O cadastro com senha nao esta aberto. Entre com o endereco e a senha da sua caixa de e-mail.':
    'O cadastro com senha não está aberto. Entre com o endereço e a senha da sua caixa de e-mail.',
  'Esta senha aparece em vazamentos publicos conhecidos. Escolha outra que voce nunca usou em outro servico.':
    'Esta senha aparece em vazamentos públicos conhecidos. Escolha outra que você nunca usou em outro serviço.',
  'Esta caixa entra pelo proprio provedor, nao por senha. Entre com a conta Way Mail e adicione a caixa por la.':
    'Esta caixa entra pelo próprio provedor, não por senha. Entre com a conta Way Mail e adicione a caixa por lá.',
  'Este endereco ja tem uma conta Way Mail com senha propria. Entre com a conta Way Mail.':
    'Este endereço já tem uma conta Way Mail com senha própria. Entre com a conta Way Mail.',
  'Informe o codigo de verificacao em duas etapas.':
    'Informe o código de verificação em duas etapas.',
  'Nao foi possivel criar a conta com este endereco.':
    'Não foi possível criar a conta com este endereço.',
  'Sessao expirada. Entre novamente.': 'Sessão expirada. Entre novamente.',
  'Codigo invalido.': 'Código inválido.',
  // A API usa a mesma frase para mensagem enviada e para cancelada: o texto de tela
  // nao afirma qual das duas foi.
  'A mensagem ja saiu. Nao da mais para cancelar.':
    'Não dá mais para cancelar: a mensagem já foi enviada ou cancelada.',
  'A mensagem ja saiu ou foi cancelada. Nao da mais para mudar.':
    'Não dá mais para mudar o horário: a mensagem já foi enviada ou cancelada.',
};

/** Rótulo (com artigo) do campo do body que a API cita no prefixo `body/<campo>`. */
const ROTULO_DO_CAMPO: Record<string, string> = {
  name: 'O nome',
  displayName: 'O nome de exibição',
  subject: 'O assunto',
  title: 'O título',
  email: 'O e-mail',
  notes: 'As notas',
  organization: 'A empresa',
  jobTitle: 'O cargo',
};

// Palavras sem acento que a API escreve e que nao tem outra leitura em portugues.
const PALAVRAS: Record<string, string> = {
  nao: 'não',
  ja: 'já',
  so: 'só',
  voce: 'você',
  endereco: 'endereço',
  invalido: 'inválido',
  invalida: 'inválida',
  valido: 'válido',
  codigo: 'código',
  sessao: 'sessão',
  verificacao: 'verificação',
  sincronizacao: 'sincronização',
  requisicao: 'requisição',
  autenticacao: 'autenticação',
  possivel: 'possível',
  disponivel: 'disponível',
  necessaria: 'necessária',
  servico: 'serviço',
  publicos: 'públicos',
  proprio: 'próprio',
  credencial: 'credencial',
  conexao: 'conexão',
  configuracao: 'configuração',
};

function acentuar(texto: string): string {
  return texto
    .replace(/\b(nao|ja) esta\b/gi, (_: string, w: string) => w + ' está')
    .replace(
      /\bnao da (mais )?para\b/gi,
      (m, mais: string | undefined) =>
        (m[0] === 'N' ? 'Não' : 'não') + ' dá ' + (mais ?? '') + 'para',
    )
    .replace(/\b[a-z]+\b/gi, (w) => {
      const certo = PALAVRAS[w.toLowerCase()];
      if (certo === undefined) return w;
      return w[0] === w[0]!.toUpperCase() ? certo[0]!.toUpperCase() + certo.slice(1) : certo;
    });
}

/** Campo citado no prefixo do zod (`body/name ...`), se houver. */
export function campoDoErro(mensagem: string): string | undefined {
  return /^body\/(\S+) /.exec(mensagem)?.[1];
}

/**
 * Texto de tela para qualquer mensagem de erro da API: troca o texto cru do zod
 * (em ingles) por pt-BR, tira o prefixo tecnico e acentua o que a API escreve
 * sem acento. Chamado uma vez, em `ErroDaApi`.
 */
export function textoDaApi(mensagem: string): string {
  // Validação do zod: "body/servidor Servidor invalido., Servidor invalido."
  if (/^body\/\S+ /.test(mensagem) && /Servidor invalido/.test(mensagem)) {
    return 'Servidor inválido. Informe só o nome, por exemplo srv.bwserver.com.br.';
  }
  const campo = campoDoErro(mensagem);
  const rotulo = (campo !== undefined ? ROTULO_DO_CAMPO[campo] : undefined) ?? 'Este campo';
  const grande = /Too big: expected string to have <=(\d+) characters/.exec(mensagem);
  if (grande !== null) return `${rotulo} pode ter até ${grande[1]} caracteres.`;
  const pequeno = /Too small: expected string to have >=(\d+) characters/.exec(mensagem);
  if (pequeno !== null) {
    return pequeno[1] === '1'
      ? 'Preencha este campo.'
      : `${rotulo} precisa ter ao menos ${pequeno[1]} caracteres.`;
  }
  const semPrefixo = mensagem.replace(/^body\/\S+ /, '');
  return COM_ACENTO[semPrefixo] ?? acentuar(semPrefixo);
}

export const textoDaEntrada = textoDaApi;
